// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__pL83e","spinner":"styles_spinner__1dC-A","sk-rotateplane":"styles_sk-rotateplane__3OiGp"};